const constants = {};

constants.SYSADMIN = "SYSADMIN";
constants.ADMIN = "ADMIN";
constants.REPORTERPLUS = "REPORTERPLUS";
constants.VIGILANT = "VIGILANT";
constants.REPORTER = "REPORTER";
constants.USER = "USER";

export default constants;